import { render, staticRenderFns } from "./RegisteredMembers.vue?vue&type=template&id=67b893d2"
import script from "./RegisteredMembers.vue?vue&type=script&lang=js"
export * from "./RegisteredMembers.vue?vue&type=script&lang=js"
import style0 from "./RegisteredMembers.vue?vue&type=style&index=0&id=67b893d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports